import { render, staticRenderFns } from "./Intent.vue?vue&type=template&id=f66fbfa8&"
import script from "./Intent.vue?vue&type=script&lang=ts&"
export * from "./Intent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports